export const GET_CONFIG_INFO = 'GET_CONFIG_INFO'
export const GET_CONFIG_INFO_FULFILLED = 'GET_CONFIG_INFO_FULFILLED'
export const GET_CONFIG_INFO_REJECTED = 'GET_CONFIG_INFO_REJECTED'
export const SET_CONFIG_INFO = 'SET_CONFIG_INFO'
export const SET_CONFIG_INFO_FULFILLED = 'SET_CONFIG_INFO_FULFILLED'
export const SET_CONFIG_INFO_REJECTED = 'SET_CONFIG_INFO_REJECTED'
export const GET_ROUTE_INFO = 'GET_ROUTE_INFO'
export const GET_ROUTE_INFO_FULFILLED = 'GET_ROUTE_INFO_FULFILLED'
export const SET_ROUTE_INFO = 'SET_ROUTE_INFO'
export const SET_ROUTE_INFO_FULFILLED = 'SET_ROUTE_INFO_FULFILLED'
